const mapAppliedStoreFilters = (appliedStoreFilters)=>Object.entries(appliedStoreFilters).flatMap(([filterName, options])=>{
        const formattedFilterKey = filterName.startsWith('c_') ? filterName.slice(2) : filterName;
        return options.map((option)=>{
            const formattedOptionKey = option;
            return {
                name: formattedFilterKey,
                value: formattedOptionKey
            };
        });
    })
;

export { mapAppliedStoreFilters };
//# sourceMappingURL=map-applied-store-filters.js.map
